import SectionHero from '@/components/SectionHero';
import DefaultSolutionTemplate from '@/components/templates/Solution';
import { sdk } from '@/lib/graphcms';

export default function StructuredContent({ solution, preview }) {
  return (
    <DefaultSolutionTemplate page={solution} preview={preview}>
      <SectionHero
        title="Create once, publish everywhere"
        description="GraphCMS gives you all the tools you need to define clearly structured content into models that can be delivered via API to all digital frontends"
      />
    </DefaultSolutionTemplate>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { solution } = await sdk({ preview }).useCasePage({
    slug: 'structured-content',
  });

  if (!solution) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      preview,
      solution,
    },
    revalidate: 3600,
  };
};
